function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 50.4037C40 51.972 38.2772 52.9301 36.9449 52.1028L21.0551 42.2352C20.4089 41.8339 19.5911 41.8339 18.9449 42.2352L3.05511 52.1028C1.72281 52.9301 1.77292e-07 51.972 3.14395e-07 50.4037L4.54598e-06 2C4.64255e-06 0.895428 0.895436 3.96067e-07 2 4.92632e-07L38 3.63985e-06C39.1046 3.73642e-06 40 0.895435 40 2L40 50.4037Z",
  fill: "url(#paint0_linear_49714_30437)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_49714_30437",
  x1: 20,
  y1: 54,
  x2: 20,
  y2: -0.00000115241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18A0FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989583,
  stopColor: "#06D9B1"
})));

var SvgTrending = function SvgTrending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trending.b046cac7.svg";
export { ForwardRef as ReactComponent };